import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../Styles/home.css';

const heroBackgrounds = [
  '/assets/Home_bg_img_1.png',
  '/assets/Home_bg_img_2.JPG',
  '/assets/Home_bg_img_3.png',
];

const hrCards = [
  {
    title: 'HR Leadership Development',
    content:
      'Equip HR professionals and business leaders with future-ready leadership skills through summits, workshops, and executive learning experiences.',
  },
  {
    title: 'Workplace Culture & Employer Branding',
    content:
      'Build high-performing workplaces by strengthening employer reputation, employee engagement, and organizational culture.',
  },
  {
    title: 'Talent & Workforce Transformation',
    content:
      'Enable organizations to attract, develop, and retain exceptional talent while preparing for the future of work.',
  },
  {
    title: 'HR Innovation & Digital Transformation',
    content:
      'Drive business success by embracing HR technology, data-driven strategies, and innovative people practices that transform the employee experience.',
  },
];

function Home() {
  const [activeSlide, setActiveSlide] = useState(0);
  const [openCard, setOpenCard] = useState(-1); // all cards collapsed by default — only open on click

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % heroBackgrounds.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const toggleCard = (index) => {
    setOpenCard(openCard === index ? -1 : index);
  };

  return (
    <>
      <section className="hero">
  {/* Full-screen looping background */}
  <div className="hero-bg-slideshow">
    {heroBackgrounds.map((src, index) => (
      <img
        key={src}
        src={src}
        alt="Vanakkam HRD community"
        className={`hero-bg-slide ${index === activeSlide ? 'active' : ''}`}
      />
    ))}
  </div>

  {/* Dark left-to-right shade for text readability */}
  <div className="hero-overlay"></div>

  {/* Actual content, sits above the background */}
  <div className="hero-content">
    <div className="hero-left">
      <h1 className="hero-title">
        <span className="text-engage">ENGAGE.</span>
        <span className="text-inspire">INSPIRE.</span>
        <span className="text-transform">TRANSFORM.</span>
      </h1>

      <p className="hero-subtitle">
        Elevate Human Potential, Community - Driven People Success.
      </p>

      <Link to="/join" className="hero-btn">
        Join Our Community
        <img
          src="/assets/home_arrow_icon.png"
          alt="Arrow Icon"
          className="arrow-icon"
        />
      </Link>
    </div>
  </div>
</section>

      {/* ===== SECTION 2: About / HR Stars ===== */}
      <section className="about-section">
        <div className="about-left">
        <img
          src="/assets/home_02.png"
          alt="HR professionals workspace illustration"
          className="about-illustration"
        />
      </div>

        <div className="about-right">
          <h2 className="about-heading">
            We Are? <span className="about-highlight">HR STARS!</span>
          </h2>

          <p className="about-text">
            Vanakkam HRD is a thriving community of forward-thinking HR professionals and business leaders shaping the future of work. We bring together talent experts and people leaders to share insights, discuss challenges, and build impactful solutions - driving HR innovation from local to global.
          </p>

          <p className="about-text">
           Join a highly curated ecosystem of People Success and HR leaders across India. Connect, collaborate, and grow through powerful conversations, shared knowledge, and real - world solutions.
          </p>
        </div>
      </section>

      {/* ===== SECTION 3: Stats ===== */}
      <section className="stats-section">
        <div className="stat-item">
         <div className="stat-circle">
        <img
          src="/assets/Home_icon_1.png"
          alt="Home Icon"
          className="stat-icon"
        />
      </div>
          <h3 className="stat-number">10000+</h3>
          <p className="stat-label">Community Members</p>
        </div>

        <div className="stat-item">
          <div className="stat-circle">
          <img
            src="/assets/Home_icon_2.png"
            alt="Icon"
            className="stat-icon"
          />
        </div>
          <h3 className="stat-number">200+</h3>
          <p className="stat-label">Overall Engagements</p>
        </div>

        <div className="stat-item">
          <div className="stat-circle">
            <img
              src="/assets/Home_icon_3.png"
              alt="Icon"
              className="stat-icon"
            />
          </div>
          <h3 className="stat-number">100+</h3>
          <p className="stat-label">Partners</p>
        </div>

        <div className="stat-item">
          <div className="stat-circle">
            <img
              src="/assets/Home_icon_4.png"
              alt="Icon"
              className="stat-icon"
            />
          </div>
          <h3 className="stat-number">50+</h3>
          <p className="stat-label">Events Hosted</p>
        </div>

        <div className="stat-item">
          <div className="stat-circle">
            <img
              src="/assets/Home_icon_5.png"
              alt="Icon"
              className="stat-icon"
            />
          </div>
          <h3 className="stat-number">20+</h3>
          <p className="stat-label">Industries Covered</p>
        </div>

        <div className="stat-item">
          <div className="stat-circle">
            <img
              src="/assets/Home_icon_6.png"
              alt="Icon"
              className="stat-icon"
            />
          </div>
          <h3 className="stat-number">90%</h3>
          <p className="stat-label">Community Growth Rate</p>
        </div>
      </section>

      {/* ===== SECTION 4: Transformation Through HR ===== */}
      <section className="transformation-section">
        <h2 className="transformation-heading">
          <span className="transformation-highlight">Transformation</span> Through HR
        </h2>

        <div className="transformation-content">
          <div className="transformation-left">
            <img
              src="/assets/home_01.png"
              alt="HR transformation illustration"
              className="transformation-image"
            />
          </div>

          <div className="transformation-right">
            {hrCards.map((card, index) => (
              <div className="hr-card" key={card.title}>
                <button
                  type="button"
                  className="hr-card-header"
                  onClick={() => toggleCard(index)}
                >
                  <span className="hr-card-dot"></span>
                  <span className="hr-card-title">{card.title}</span>
                  <span className={`hr-card-arrow ${openCard === index ? 'open' : ''}`}>
                  <img 
                    src="/assets/hone_dd_arrow.png" 
                    alt="Dropdown Arrow" 
                    className="hr-card-arrow-img"
                  />
                </span>
                </button>

                {openCard === index && (
                  <div className="hr-card-body">
                    <p>{card.content}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== SECTION 5: What Sets Us Apart ===== */}
      <section className="features-section">
        <h2 className="features-heading">What Sets Us Apart</h2>
        <p className="features-subtext">
          At Vanakkam HRD, we believe community should create impact—not just conversations.
        </p>

        <div className="features-grid">
          <div className="feature-card">
                      <div className="feature-icon icon-orange">
            <img
              src="/assets/Home_grid_icon_1.png"
              alt="Feature Icon"
              className="feature-icon-img"
            />
          </div>
            <p className="feature-text">Curated Community members</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon icon-orange">
              <img
                src="/assets/Home_grid_icon_2.png"
                alt="Feature Icon"
                className="feature-icon-img"
              />
            </div>
            <p className="feature-text">Insightful, real-world discussions</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon icon-orange">
              <img
                src="/assets/Home_grid_icon_3.png"
                alt="Feature Icon"
                className="feature-icon-img"
              />
</div>
            <p className="feature-text">
             Focus on Talent, People Success &amp; Branding
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon icon-orange">
              <img
                src="/assets/Home_grid_icon_4.png"
                alt="Feature Icon"
                className="feature-icon-img"
              />
            </div>
            <p className="feature-text">Opportunities to collaborate &amp; grow</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon icon-orange">
            <img
              src="/assets/Home_grid_icon_5.png"
              alt="Feature Icon"
              className="feature-icon-img"
            />
          </div>
            <p className="feature-text">A platform to learn, lead, and influence</p>
          </div>

          <div className="feature-card">
           <div className="feature-icon icon-orange">
            <img
              src="/assets/Home_grid_icon_6.png"
              alt="Feature Icon"
              className="feature-icon-img"
            />
          </div>
            <p className="feature-text">
              Execution Mindset - Turning ideas into action
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;